export const products = [
  {
    id: 'chicken-jerky',
    name: "Dehydrated Chicken Jerky",
    weight: '70g',
    price: 499,
    image: 'https://customer-assets.emergentagent.com/job_16c39ce2-3ee2-4676-8243-6d618e5f4817/artifacts/roo3fenq_FurrBowl%E2%80%99s%20%2812%20x%2016%20cm%29.png',
  },
  {
    id: 'chicken-feet',
    name: "Dehydrated Chicken Feet",
    weight: '10 Pcs',
    price: 399,
    image: 'https://customer-assets.emergentagent.com/job_16c39ce2-3ee2-4676-8243-6d618e5f4817/artifacts/x4j05dqo_FurrBowl%E2%80%99s%20%2812%20x%2016%20cm%29%20%281%29.png',
  },
  {
    id: 'chicken-wings',
    name: "Dehydrated Chicken Wings",
    weight: '80g',
    price: 599,
    image: 'https://customer-assets.emergentagent.com/job_16c39ce2-3ee2-4676-8243-6d618e5f4817/artifacts/rx86gwm6_FurrBowl%E2%80%99s%20%2812%20x%2016%20cm%29%20%282%29.png',
  },
  {
    id: 'chicken-cartilage',
    name: "Dehydrated Chicken Cartilage",
    weight: '5 Pcs',
    price: 399,
    image: 'https://customer-assets.emergentagent.com/job_16c39ce2-3ee2-4676-8243-6d618e5f4817/artifacts/k6naz3zp_FurrBowl%E2%80%99s%20%2812%20x%2016%20cm%29%20%289%29.png',
  },
  {
    id: 'anchovies',
    name: "Dehydrated Anchovies",
    weight: '70g',
    price: 899,
    image: 'https://customer-assets.emergentagent.com/job_16c39ce2-3ee2-4676-8243-6d618e5f4817/artifacts/m04e2ut5_FurrBowl%E2%80%99s%20%2812%20x%2016%20cm%29%20%283%29.png',
  },
  {
    id: 'sardine',
    name: "Dehydrated Sardine",
    weight: '70g',
    price: 799,
    image: 'https://customer-assets.emergentagent.com/job_16c39ce2-3ee2-4676-8243-6d618e5f4817/artifacts/cebkg80j_FurrBowl%E2%80%99s%20%2812%20x%2016%20cm%29%20%284%29.png',
  },
  {
    id: 'mackerel',
    name: "Dehydrated Mackerel",
    weight: '70g',
    price: 799,
    image: 'https://customer-assets.emergentagent.com/job_16c39ce2-3ee2-4676-8243-6d618e5f4817/artifacts/x82seewm_FurrBowl%E2%80%99s%20%2812%20x%2016%20cm%29%20%285%29.png',
  },
  {
    id: 'fish-powder',
    name: "Fish Powder",
    weight: '70g',
    price: 699,
    image: 'https://customer-assets.emergentagent.com/job_16c39ce2-3ee2-4676-8243-6d618e5f4817/artifacts/ogu71n0q_FurrBowl%E2%80%99s%20%2812%20x%2016%20cm%29%20%288%29.png',
  },
  {
    id: 'all-in-one-supplement',
    name: "All in One Supplement",
    weight: '100g',
    price: 699,
    image: 'https://customer-assets.emergentagent.com/job_16c39ce2-3ee2-4676-8243-6d618e5f4817/artifacts/i6q9h55z_FurrBowl%E2%80%99s%20%2812%20x%2016%20cm%29%20%286%29.png',
  },
  {
    id: 'seed-blend',
    name: "Seed Blend",
    weight: '100g',
    price: 399,
    image: 'https://customer-assets.emergentagent.com/job_16c39ce2-3ee2-4676-8243-6d618e5f4817/artifacts/q3c2h5rd_FurrBowl%E2%80%99s%20%2812%20x%2016%20cm%29%20%287%29.png',
  },
];

export const WHATSAPP_NUMBER = '918050539777';
